<template>
  <div class="basic-container overviewLeft-main">
    <div class="mian-box-style">
      <div class="main-box">
        <div class="title">
          <img src="/images/logo.png" alt="" />
          多能物联数据中心
          <span>MEIC Data Center</span>
        </div>
        <div class="x-title">
          <div class="x-title-value">园区发电量</div>
        </div>
        <div class="echart-box">
          <div id="echartsId"></div>
        </div>

        <div class="x-title">
          <div class="x-title-value">虚拟电厂状态</div>
        </div>

        <div class="three-item">
          <div class="item-box display-alite-center">
            <img src="/images/list1.png" />
            <div>
              <div class="sty1 color1">{{ powerPlantStatus.currentPower }}</div>
              <div class="sty2">当前目标功率(kW)</div>
            </div>
          </div>
          <div class="item-box display-alite-center">
            <img src="/images/list2.png" />
            <div>
              <div class="sty1-new color1">{{ powerPlantStatus.cureentState }}</div>
              <div class="sty2">当前状态</div>
            </div>
          </div>
          <div class="item-box display-alite-center">
            <img src="/images/list3.png" />
            <div>
              <div class="sty1-new color1">{{ powerPlantStatus.currentSort }}</div>
              <div class="sty2">当前执行顺序</div>
            </div>
          </div>
        </div>

        <div class="wd-style display-alite-center">
          <img src="/images/list4.png" alt="" />
          <div style="width: 100%; text-align: center">
            <div class="styBY" style="display: inline-block">当前执行策略：</div>
            <div class="sty1 color1" style="display: inline-block">{{ powerPlantStatus.currentStrategy }}</div>
          </div>
        </div>
        <div class="x-title" style="margin-top: 10px">
          <div class="x-title-value">园区数据</div>
        </div>
        <div class="yq-num">
          <div class="num-text">接入园区数量</div>
          <div class="num-item color2">{{ parseInt(yuanquNum / 10) }}</div>
          <div class="num-item color2">{{ yuanquNum % 10 }}</div>
          <div class="num-text">个</div>
        </div>
        <div class="list-img">
          <el-carousel height="230px" :interval="10000" type="card">
            <el-carousel-item v-for="item in list" :key="item.parkCode">
              <!-- <el-image :src="'http://192.168.4.205:8000/test/upload/20240401/3752214effc8d0bd2ed06c52e517edf6.png'" fit="contain"></el-image> -->
              <div class="carTitle">{{ item.name }}</div>
              <div class="carBox">
                <div
                  class="carContent"
                  :style="`background: url(${item.img.replace(
                    'http://192.168.4.205:8000',
                    'http://58.20.55.73:53441'
                  )}) no-repeat;background-size: 100% 100%;`"
                >
                  <!-- <div class="carContent" :style="`background: url(${item.img.replace('http://192.168.4.205:8000',window.location.origin)}) no-repeat;background-size: 100% 100%;`"> -->
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>

          <!-- <div class="list-item" v-for="(item, i) of list" :key="i + 'asdx'"><img
            :src="require('@/assets/img/chuNeng/icon-1.png')" alt="">{{ item.name }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {parkCarousel, virtualStation, lineEchart} from "@/api/overview";
import login from "@/mixins/login";

export default {
  name: "overviewLeft",
  mixins: [login],
  data() {
    return {
      yuanquNum: 0,
      dd: "http://192.168.4.205:8000/test/upload/20240401/3752214effc8d0bd2ed06c52e517edf6.png",
      list: [],
      loading: false,
      searchData: {
        areaCode: "",
        parkCode: "",
        name: "",
      },
      powerPlantStatus: {
        cureentState: "--",
        currentSort: "--",
        currentStrategy: "--",
        currentPower: "--",
      },
      cureList: [],
    };
  },
  mounted() {
    console.log("window.location", window.location.origin);
    this.setFontSize();
    window.addEventListener("resize", this.setFontSize);
    let lslRs = [
      {name: "00:00", value: 0},
      {name: "01:00", value: 0},
      {name: "02:00", value: 0},
      {name: "03:00", value: 0},
      {name: "04:00", value: 0},
      {name: "05:00", value: 1.4},
      {name: "06:00", value: 13.4},
      {name: "07:00", value: 65},
      {name: "08:00", value: 136.8},
      {name: "09:00", value: 203},
      {name: "10:00", value: 244.2},
      {name: "11:00", value: 212.8},
      {name: "12:00", value: 225.4},
      {name: "13:00", value: 214.6},
      {name: "14:00", value: 219.4},
      {name: "15:00", value: 211},
      {name: "16:00", value: 143.2},
      {name: "17:00", value: 76.8},
      {name: "18:00", value: 18},
      {name: "19:00", value: 0},
      {name: "20:00", value: 0},
      {name: "21:00", value: 0},
      {name: "22:00", value: 0},
      {name: "23:00", value: 0},
    ];
    let xslRs = [
      {name: "00:00", value: 0},
      {name: "01:00", value: 0},
      {name: "02:00", value: 0},
      {name: "03:00", value: 0},
      {name: "04:00", value: 0},
      {name: "05:00", value: 0.4},
      {name: "06:00", value: 57.75},
      {name: "07:00", value: 309.18},
      {name: "08:00", value: 651.48},
      {name: "09:00", value: 919.7},
      {name: "10:00", value: 1103.3},
      {name: "11:00", value: 1234.53},
      {name: "12:00", value: 1208.8},
      {name: "13:00", value: 1238.98},
      {name: "14:00", value: 1060.2},
      {name: "15:00", value: 873.4},
      {name: "16:00", value: 502.43},
      {name: "17:00", value: 311.9},
      {name: "18:00", value: 103.7},
      {name: "19:00", value: 5.3},
      {name: "20:00", value: 0},
      {name: "21:00", value: 0},
      {name: "22:00", value: 0},
      {name: "23:00", value: 0},
    ];
    this.echartsInit([
      {name: "麓松路", value: lslRs.slice(0, new Date().getHours())},
      {name: "欣盛路", value: xslRs.slice(0, new Date().getHours())},
    ]);
  },
  methods: {
    setFontSize() {
      const screenWidth =
        document.querySelector(".overviewLeft-main") && document.querySelector(".overviewLeft-main").offsetWidth;
      const fontSize = (14 * screenWidth) / 1000;
      document.documentElement.style.fontSize = fontSize + "px";
    },
    getData() {
      this.$nextTick(() => {
        this.virtualStationFn();
        // this.lineEchartFn();
      });
      this.getList();
    },
    // 虚拟电厂状态
    virtualStationFn() {
      virtualStation()
        .then((res) => {
          let _data = res.data.data;
          this.powerPlantStatus.cureentState = _data.cureentState || "--";
          this.powerPlantStatus.currentPower = _data.currentPower || "--";
          this.powerPlantStatus.currentSort = _data.currentSort || "--";
          this.powerPlantStatus.currentStrategy = _data.currentStrategy || "--";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 园区接入->虚拟电厂->光伏曲线
    lineEchartFn() {
      lineEchart()
        .then((res) => {
          let _data = res.data.data;
          this.echartsInit(_data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 电站数量
    getList(form, done) {
      this.loading = true;
      parkCarousel({
        current: 1,
        size: 99999,
        ...this.searchData,
      })
        .then((res) => {
          this.list = res.data.data;
          this.yuanquNum = this.list.length;
        })
        .finally(() => {
          this.loading = false;
          done && done();
        });
    },
    echartsInit(_data) {
      let chartDom = document.getElementById("echartsId");
      let myChart = echarts.init(chartDom);
      let axisData = ["", "", "", "", "", "", ""];
      let seriesData = [];
      let legendData = [];
      if (_data && _data.length > 0) {
        _data.forEach((item) => {
          axisData = item.value.map((item) => item.name);
          let _valList = item.value.map((item) => item.value);
          legendData.push(item.name);
          seriesData.push({
            name: item.name,
            type: "line",
            smooth: true,
            data: _valList,
          });
        });
      }
      let option = {
        tooltip: {
          trigger: "axis",
        },
        color: ["#00EEFF", "#0055FF"],
        legend: {
          data: legendData,
          icon: "rect",
          itemGap: 30,
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          left: "2%",
          right: "4%",
          bottom: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: axisData,
          axisLabel: {
            color: "#fff",
            fontSize: 16,
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "电量(kWh)",
          nameTextStyle: {
            color: "#fff",
            fontSize: 16,
            padding: [0, 40, 0, 60],
          },
          axisLabel: {
            fontSize: 16,
            color: "#fff",
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#747E94",
            },
          },
        },
        series: seriesData,
      };

      myChart.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-carousel__mask {
  background: none;
}
</style>
<style scoped lang="scss">
@import "@/styles/tools";

.color1 {
  color: #34ffb0 !important;
}

.color2 {
  color: #f2ff2e !important;
}

.img-cover-norepeat {
  background-size: 100%;
  background-repeat: no-repeat;
  background-origin: content-box;
}

.display-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.display-alite-center {
  display: flex;
  align-items: center;
}

.basic-container {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // #####
  height: calc(100% - 10px) !important;
  position: relative;
  // font-family: Microsoft YaHei, serif;
  font-family: Arial, sans-serif;
}

.overviewLeft-main {
  width: 1000px;
  height: 1080px;
  height: 100%;
  // #####
  overflow: hidden;
  box-sizing: border-box;
}

.mian-box-style {
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(2, 22, 67, 1);
  text-align: center;
}

.main-box {
  width: 920px;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0px auto;

  .title {
    @extend .display-alite-center;
    font-size: 2rem;
    margin: rem(40) 0 rem(15);
    font-weight: 700;

    img {
      width: 10.285rem;
      height: 1.857rem;
      margin-right: 1.142rem;
    }

    span {
      font-style: italic;
      color: #009bdb;
      opacity: 0.8;
    }
  }

  .x-title {
    height: rem(34);
    position: relative;
    @extend .img-cover-norepeat;
    background-size: contain;
    background-image: url("../assets/images/fhTitle.png");
  }

  //.x-title-line,
  //.x-title-two {
  //  width: rem(7);
  //  height: rem(14);
  //  @extend .img-cover-norepeat;
  //  background-image: url("../../assets/img/fhTitleLine.png");
  //  position: absolute;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  left: rem(20);
  //}

  .x-title-two {
    left: rem(20 + 8);
  }

  .x-title-value {
    // font-family: "YouShe";
    font-family: Arial, sans-serif;
    margin-left: rem(45);
    font-size: rem(20);
    color: rgba(255, 255, 255, 1);
    text-align: left;
    letter-spacing: 0;
    line-height: 2;
  }

  .yq-num {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: rem(15);

    .num-text {
      font-size: rem(18);
      font-weight: 400;
      line-height: rem(26);
      margin: 0px rem(20);
    }

    .num-item {
      width: rem(53.92);
      height: rem(54);
      margin: 0px rem(6);
      @extend .img-cover-norepeat;
      background-image: url("../assets/images/bg1.png");
      font-size: rem(40);
      font-weight: 600;
      color: rgba(0, 238, 255, 1);
      text-align: center;
    }
  }

  .left-list {
    @extend .display-center;
    flex-wrap: wrap;
    justify-content: start;
    align-items: start;
    margin-bottom: rem(20);
    width: 100%;
    height: 15rem;
    overflow: hidden;

    .list-item {
      @extend .display-alite-center;
      width: 49%;
      height: rem(55);
      margin-left: rem(16);
      margin-top: rem(15);
      font-size: rem(18);
      line-height: rem(26);
      @extend .img-cover-norepeat;
      background-image: url("../assets/images/bg2.png");

      &:nth-child(2n-1) {
        margin-left: 0px;
      }

      img {
        width: rem(21.94);
        height: rem(20.37);
        margin-left: rem(30);
        margin-right: rem(15);
      }
    }
  }

  .list-img {
    width: 100%;
    // height: 13rem;/
    padding-bottom: 20px;

    .carTitle {
      text-align: center;
      line-height: 30px;
      font-size: 20px;
    }

    .carBox {
      width: 100%;
      padding: 0 50px;
      height: 100%;
      box-sizing: border-box;
      .carContent {
        width: 100%;
        height: 100%;
      }
    }
  }

  .three-item {
    @extend .display-center;
    justify-content: space-between;
    margin: rem(20) 0px;

    .item-box {
      width: rem(293);
      height: rem(104);
      @extend .img-cover-norepeat;
      background-image: url("../assets/images/bg3.png");

      img {
        width: rem(43.33);
        height: rem(43.33);
        margin: 0px rem(26.25);
      }

      .sty1 {
        font-size: rem(30);
        font-weight: 600;
        color: rgba(0, 238, 255, 1);
      }

      .sty1-new {
        font-size: rem(24);
        font-weight: 600;
        color: rgba(0, 238, 255, 1);
      }

      .sty2 {
        font-size: rem(14);
        margin-top: rem(4);
      }
    }
  }

  .wd-style {
    @extend .img-cover-norepeat;
    background-image: url("../assets/images/bg4.png");
    height: rem(104);

    img {
      width: rem(45.83);
      height: rem(41.67);
      margin: 0px rem(22);
    }

    .styBY {
      font-size: rem(22);
      font-weight: 400;
    }

    .sty1 {
      font-size: rem(22);
      font-weight: 600;
      line-height: rem(31.86);
      color: rgba(0, 238, 255, 1);
    }

    .sty2 {
      margin-top: rem(8);
      font-size: rem(14);
    }
  }

  .echart-box {
    width: 100%;
    // flex: 1;
    // height: 230px;
    height: 25%;
    padding-top: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;

    #echartsId {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
